import { createContext } from 'react';

export const MasterContext = createContext("");